import AbstractRequestTask from '../AbstractRequestTask';

class netWFTask extends AbstractRequestTask {

  constructor(params) {
    super();
    if (params.customEndPoint) {
      this.__urlDominioMicrofwk = params.customEndPoint;
      delete params.customEndPoint;
    }

    this.params = params;
  }

  getUrl() {
    const urlDominioMicrofwk = this.__urlDominioMicrofwk;
    return urlDominioMicrofwk;
  }

  getParams() {
    const params = super.getParams();
    this.params = Object.assign(params, this.params);

    return params;
  }

  success(data, b) {
    const isValid = super.success(data, b);
    if (!isValid) {
      return this.reject(data, b);
    }
    return this.resolve(data);
  }
}

export default netWFTask;